/**
 * Labstep
 *
 * @module components/ExperimentWorkflowLink/Action/Menu
 * @desc Action Menu for experiment workflow link
 */

import { ExperimentWorkflowLinkActionDelete } from 'labstep-web/components/ExperimentWorkflowLink/Action/Delete';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { ExperimentWorkflowLinkActionMenuProps } from './types';

export const ExperimentWorkflowLinkActionMenu: React.FC<
  ExperimentWorkflowLinkActionMenuProps
> = ({ experimentWorkflowLink, type, actions = [] }) => (
  <ActionMenu type={type}>
    {actions.includes('delete') && (
      <ExperimentWorkflowLinkActionDelete
        experimentWorkflowLink={experimentWorkflowLink}
      />
    )}
  </ActionMenu>
);

ExperimentWorkflowLinkActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
